import React from "react";
import { Outlet } from "react-router-dom";
import MTopBar from "../ui/atoms/MTopBar";
import { MExit } from "../ui/atoms/MExit";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * NoFooterLayout: Used for 3rd Level Screens.
 * Renders a top bar, main content, and optionally footer navigation
 */
interface NoFooterLayoutProps extends React.PropsWithChildren {
  exitPath?: string;
  hideExit?: boolean;
  hideBack?: boolean;
  level?: number;
  showGradient?: boolean;
  showTopBarGradient?: boolean;
  showFooter?: boolean;
  onEdit?: () => void;
  showEdit?: boolean;
  onBack?: () => void;
}

const NoFooterLayout: React.FC<NoFooterLayoutProps> = ({
  children,
  exitPath,
  hideExit,
  hideBack = false,
  level = 2,
  showGradient = false,
  showTopBarGradient = false,
  showFooter = false,
  onEdit,
  showEdit = false,
  onBack,
}) => {
  return (
    <div
      className="flex flex-col relative overflow-hidden"
      style={{
        height: "calc(var(--vh, 1vh) * 100)",
        background: showGradient
          ? "linear-gradient(181deg, #FBF6FF 77.96%)"
          : "#fff",
      }}
    >
      <MTopBar
        hideProfilePicker
        hideBack={hideBack}
        onEdit={onEdit}
        showEdit={showEdit}
        onBack={onBack}
        showTopBarGradient={showTopBarGradient}
      />
      <MExit
        className="absolute top-[0] right-[24px] mt-[64px] z-10"
        path={exitPath}
        hideExit={hideExit}
        level={level}
      />

      <main
        className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden bg-white"
        style={{
          // Footer is position:fixed (85px) and overlays content — reserve
          // space for it (plus the bottom safe-area inset) so the last
          // content isn't hidden behind it.
          paddingBottom: showFooter
            ? "calc(85px + env(safe-area-inset-bottom))"
            : "env(safe-area-inset-bottom)",
        }}
      >
        {children ? children : <Outlet />}
      </main>

      {showFooter && <MFooterNavigation />}
    </div>
  );
};

export default NoFooterLayout;
